<template lang="">
  <div>
    <div v-if="!result" class="grid grid-flow-row md:grid-flow-col gap-4 md:gap-10 md:grid-cols-8 px-3 my-10">
      <div class="md:col-start-1 md:col-end-3">
        <nav aria-label="Progress">
          <div class="border border-gray-200 rounded">
            <div v-for="(step, index) in steps" :key="step.name">
              <template v-if="step.completed">
                <div class="relative">
                  <div v-if="step == activeStep" class="absolute w-2 h-full left-0 top-0 bg-primary"></div>
                  <div
                    @click="setStep(step)"
                    class="flex items-center px-4 py-2 cursor-pointer"
                  >
                    <span style="min-width: 40px; min-height:40px;" class="flex justify-center items-center rounded-full bg-primary">
                      <font-awesome-icon icon="check" class=" text-white text-lg" />
                    </span>

                    <div class="ml-5">
                      <p class="text-primary font-bold uppercase">{{ step.name }}</p>
                      <p class="text-gray-500 text-sm">{{ step.description }}</p>
                    </div>
                  </div>
                </div>
              </template>

              <template v-else-if="step === activeStep || (steps[index-1] == activeStep && activeStep.completed)">
                <div class="relative">
                  <div v-if="step === activeStep" class="absolute w-2 h-full left-0 top-0 bg-primary"></div>
                  <div
                    @click="setStep(step)"
                    class="flex items-center px-4 py-2 cursor-pointer"
                  >
                    <span style="min-width: 40px; min-height:40px;" class="flex justify-center items-center rounded-full border-2 font-bold border-primary">
                      {{ index + 1 }}
                    </span>

                    <div class="ml-5">
                      <p class="text-primary font-bold uppercase">{{ step.name }}</p>
                      <p class="text-gray-500 text-sm">{{ step.description }}</p>
                    </div>
                  </div>
                </div>
              </template>

              <template v-else>
                <div class="flex items-center px-4 py-2">
                  <span style="min-width: 40px; min-height:40px;" class="flex justify-center items-center w-10 h-10 rounded-full border text-gray-500 border-gray-500">
                    {{ index + 1 }}
                  </span>

                  <div class="ml-5">
                    <p class="text-gray-500 font-bold uppercase">{{ step.name }}</p>
                    <p class="text-gray-500 text-sm">{{ step.description }}</p>
                  </div>
                </div>
              </template>

              <template v-if="index < steps.length-1">
                <div class="h-px bg-gray-200"/>
              </template>
            </div>
          </div>
        </nav>
      </div>
      <div class="mt-6 md:mt-0 md:col-start-3 md:col-end-9 md:px-8">
        <h2 class="text-xl font-bold text-primary mb-4">{{ activeStep.name }}</h2>

        <div v-if="unavailable" class="p-4 mb-6 border border-red-300 bg-red-50 rounded-md text-sm text-red-700">
          {{ unavailable }}
        </div>

        <div v-if="activeStep === steps[0]">
          <form class="grid grid-cols-6 gap-y-6 gap-x-4" autocomplete="on">

            <div class="col-span-6">
              <p class="text-sm text-primary">Diese Daten werden benutzt um einen Ansprechpartner zu haben und um den ersten Mitarbeiter anzulegen.</p>
            </div>

            <div class="col-start-1 col-span-3">
              <select v-model="form.contact.type" class="border border-gray-300 p-2 text-sm rounded-md outline-none">
                <option value="" disabled selected>-- Option auswählen --</option>
                <option value="MALE">Herr</option>
                <option value="FEMALE">Frau</option>
                <option value="COMPANY">Firma</option>
              </select>
              <p v-if="v$.form.contact.type.$errors[0] || serverErrors.salutation" class="w-full mt-1 bg-white text-sm text-red-500">
                {{ serverErrors.salutation || 'Dies ist ein Pflichtfeld!' }}
              </p>
            </div>

            <v-label class="col-start-1 col-span-3" title="Vorname">
              <v-input v-model="form.contact.first_name" :error="fieldError('first_name', v$.form.contact.first_name)" name="given-name" type="text" />
            </v-label>

            <v-label class="col-span-3" title="Nachname">
              <v-input v-model="form.contact.last_name" :error="fieldError('last_name', v$.form.contact.last_name)" name="family-name" type="text" />
            </v-label>

            <v-label class="col-start-1 col-span-3" title="E-Mail">
              <v-input v-model="form.contact.mail" :error="fieldError('email', v$.form.contact.mail)" icon="envelope" name="email" type="email" />
            </v-label>

            <v-label class="col-span-3" title="Telefonnummer">
              <v-input v-model="form.contact.phone" :error="fieldError('phone', v$.form.contact.phone)" icon="phone" name="tel" type="tel" />
            </v-label>

            <h4 class="col-start-1 col-span-6">Adressdaten</h4>

            <v-label class="col-span-5" title="Straße">
              <v-input v-model="form.contact.street" :error="fieldError('street', v$.form.contact.street)" name="address-line1" type="text" />
            </v-label>

            <v-label class="col-span-1" title="Hausnummer">
              <v-input v-model="form.contact.number" :error="fieldError('house_number', v$.form.contact.number)" name="address-line2" type="text" />
            </v-label>

            <v-label class="col-start-1 col-span-1" title="Postleitzahl">
              <v-input v-model="form.contact.zip" :error="fieldError('zip', v$.form.contact.zip)" name="postal-code" type="text" />
            </v-label>

            <v-label class="col-span-5" title="Stadt">
              <v-input v-model="form.contact.city" :error="fieldError('city', v$.form.contact.city)" name="address-level2" type="text" />
            </v-label>
          </form>

          <v-button class="mt-6" @click="nextStep(steps[1])">Nächster Schritt</v-button>

        </div>
        <div v-if="activeStep === steps[1]" class="mt-4">
          <form class="grid grid-cols-6 gap-y-6 gap-x-4">

            <div class="col-span-3 md:col-span-6">
              <p class="text-sm text-primary">Diese Daten werden benutzt für die Rechnungsgenerierung und zur Erstellung Ihrer JONKU Anwendung.</p>
            </div>

            <v-label class="col-start-1 col-end-4" title="Firmenname">
              <v-input v-model="form.company.company_name" :error="fieldError('company', v$.form.company.company_name)" name="organization" />
            </v-label>

            <v-label class="col-start-1 col-end-4" title="Website">
              <v-input v-model="form.company.homepage" :error="fieldError('homepage', v$.form.company.homepage)" name="url" />
            </v-label>

            <h4 class="col-start-1 col-span-6">Bankdaten</h4>
            <p class="col-start-1 col-span-6 text-sm text-gray-500">Diese Bankverbindung wird dem Kunden auf der Rechnung angezeigt. Von diesem Konto werden auch die JONKU-Kosten eingezogen, sofern Sie im nächsten Schritt kein abweichendes Abbuchungskonto angeben.</p>
            <iban-form
              v-model="form.company.bank"
              :validation="v$.form.company.bank"
              :server-errors="{ iban: serverErrors.iban, owner: serverErrors.bank_owner }"
              :token="token"
              prefix="invoice"
              class="col-start-1 col-span-6"
            />

            <h4 class="col-start-1 col-span-6">Steuerdaten</h4>
            <p class="col-start-1 col-span-6 text-sm text-gray-500">Die Steuerdaten sind optional und können später im System nachgepflegt werden.</p>

            <v-label class="col-start-1 col-span-3" title="Steuernummer">
              <v-input v-model="form.company.tax" :error="fieldError('tax_number', v$.form.company.tax)" />
            </v-label>

            <v-label class="col-span-3" title="Umsatzsteuer-Identifikationsnummer (USt-IdNr.)">
              <v-input v-model="form.company.salestax" :error="fieldError('vat_id', v$.form.company.salestax)" placeholder="DE123456789" />
            </v-label>

            <v-label class="col-start-1 col-span-3" title="Handelsregisternummer">
              <v-input v-model="form.company.commercial_register_number" :error="fieldError('register_number', v$.form.company.commercial_register_number)" />
            </v-label>

            <v-label class="col-span-3" title="Registergericht">
              <v-input v-model="form.company.registration_court" :error="fieldError('register_court', v$.form.company.registration_court)" />
            </v-label>
          </form>

          <v-button class="mt-6" @click="nextStep(steps[2])">Nächster Schritt</v-button>
        </div>
        <div v-else-if="activeStep === steps[2]">
          <div class="grid grid-cols-6 gap-y-6 gap-x-4">

            <v-label class="col-start-1 col-end-6 md:col-end-3" title="Name und Url der Anwendung">
              <v-input
                v-model="form.instance.name"
                text=".jonku.net"
                :error="fieldError('subdomain', v$.form.instance.name)"
                maxlength="63"
                autocapitalize="none"
                spellcheck="false"
                @blur="checkSubdomain"
              />
              <p v-if="subdomainStatus" class="mt-1 text-sm" :class="subdomainStatus.ok ? 'text-green-600' : 'text-gray-500'">{{ subdomainStatus.text }}</p>
            </v-label>

            <h4 class="col-start-1 col-span-6">Abbuchungskonto</h4>
            <p class="col-start-1 col-span-6 text-sm text-gray-500">Die JONKU-Kosten werden von der Bankverbindung aus Schritt 2 eingezogen<template v-if="form.company.bank.iban"> ({{ form.company.bank.iban }})</template>.</p>

            <label class="col-start-1 col-span-6 flex items-start text-sm text-gray-700 cursor-pointer">
              <input v-model="form.instance.debitDifferent" type="checkbox" class="mt-0.5 mr-2 rounded border-gray-300 text-primary focus:ring-primary" />
              <span>Abweichendes Abbuchungskonto für die JONKU-Kosten angeben</span>
            </label>

            <iban-form
              v-if="form.instance.debitDifferent"
              v-model="form.instance.debit"
              :validation="v$.form.instance.debit"
              :server-errors="{ iban: serverErrors.debit_iban, owner: serverErrors.debit_bank_owner }"
              :token="token"
              prefix="debit"
              class="col-start-1 col-span-6"
            />

            <label class="col-start-1 col-span-6 flex items-start text-sm text-gray-700 cursor-pointer">
              <input v-model="form.instance.acceptPrivacy" type="checkbox" class="mt-0.5 mr-2 rounded border-gray-300 text-primary focus:ring-primary" />
              <span>Ich habe die <router-link to="/datenschutz" target="_blank" class="text-blue-900 underline">Datenschutzerklärung</router-link> gelesen und bin einverstanden, dass meine Angaben zur Einrichtung und Abrechnung meines JONKU-Systems verarbeitet werden.</span>
            </label>
            <p v-if="fieldError('accept_privacy', v$.form.instance.acceptPrivacy)" class="col-start-1 col-span-6 -mt-4 text-sm text-red-500">Bitte bestätigen Sie die Datenschutzerklärung.</p>

            <!-- Honeypot: für Menschen unsichtbar, Bots füllen es aus. -->
            <div style="position:absolute;left:-9999px;top:-9999px" aria-hidden="true">
              <label>Website <input v-model="honeypot" type="text" name="website" tabindex="-1" autocomplete="off" /></label>
            </div>
          </div>

          <p v-if="registrationError" class="mt-6 text-sm text-red-500">{{ registrationError }}</p>

          <v-button class="mt-6" :disabled="submitting || !!unavailable" :class="{ 'opacity-60 cursor-wait': submitting }" @click="nextStep(null)">
            {{ submitting ? 'Wird übermittelt …' : 'Registrieren' }}
          </v-button>
        </div>
      </div>
    </div>
    <div v-if="result" class="flex justify-center mt-12 px-3">
      <div class="w-full md:w-1/2">

        <h1 class="mt-12 pb-10 text-center transform text-green-600 -rotate-3">WOHOO ES IST VOLLBRACHT!</h1>

        <h3 class="text-primary">Danke für Ihre Registrierung!</h3>
        <p class="mt-2">{{ result.message }}</p>
        <p v-if="result.queued" class="mt-2">Sie können diese Seite jetzt schließen. Sobald Ihr System fertig ist, erhalten Sie Adresse, Benutzername und Passwort per E-Mail.</p>

        <dl v-if="result.credentials" class="mt-4 p-4 border border-gray-200 rounded-md text-sm">
          <dt class="font-bold">Benutzername</dt><dd class="mb-2">{{ result.credentials.username }}</dd>
          <dt class="font-bold">Passwort</dt><dd>{{ result.credentials.password }}</dd>
        </dl>

        <p v-if="result.url" class="mt-6">
          <a :href="result.url" class="inline-flex items-center px-3 py-2 rounded-md shadow-sm text-gray-50 bg-primary hover:bg-accent">Zur Anmeldung: {{ result.url }}</a>
        </p>

        <p v-if="!result.credentials && !result.existing" class="mt-6 text-sm text-gray-500">Keine E-Mail bekommen? Bitte schauen Sie nach einigen Minuten im Spam-Ordner nach oder rufen Sie uns an: 0441 249 261 0.</p>

        <p class="mt-6">Wir bedanken uns für Ihr Vertrauen und wir hoffen dass Sie begeistert sein werden!</p>
      </div>
    </div>
  </div>
</template>
<script>
import VInput from '../components/v-input.vue';
import VLabel from '../components/v-label.vue';
import VButton from '../components/v-button.vue';
import { email, required, requiredIf, sameAs } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import IbanForm from '../components/iban-form.vue'

// Feldnamen des Servers (api.php) → Schritt, in dem das Feld steht.
const FIELD_STEP = {
  salutation: 0, first_name: 0, last_name: 0, email: 0, phone: 0, street: 0, house_number: 0, zip: 0, city: 0,
  company: 1, homepage: 1, bank_owner: 1, iban: 1, tax_number: 1, vat_id: 1, register_number: 1, register_court: 1,
  subdomain: 2, debit_bank_owner: 2, debit_iban: 2, accept_privacy: 2,
}

const SALUTATIONS = { MALE: 'herr', FEMALE: 'frau', COMPANY: 'firma' }

const UNAVAILABLE_TEXT = 'Die Online-Registrierung ist gerade nicht verfügbar. Bitte rufen Sie uns an (0441 249 261 0) oder schreiben Sie an info@jonku.net – wir richten Ihr System gern für Sie ein.'

export default {
  name: "Registration",

  components: {
    VInput,
    VButton,
    VLabel,
    IbanForm,
  },

  setup () {
    return { v$: useVuelidate() }
  },

  data() {
    return {
      steps: [
        {
          key: "contact",
          name: "Kontaktdaten",
          description: "Informationen für Kontaktmöglichkeiten",
          completed: false,
        },
        {
          key: "company",
          name: "Firmendaten",
          description: "Benötigte Daten der Firma zur Einrichtung von JONKU",
          completed: false,
        },
        {
          key: "instance",
          name: "JONKU konfigurieren",
          description: "Informationen um Ihre Anwendung zu personalisieren",
          completed: false,
        },
      ],
      activeStep: null,
      form: {
        contact: {
          //step 1
          type: '',
          first_name: '',
          last_name: '',
          mail: '',
          phone: '',
          street: '',
          number: '',
          city: '',
          zip: '',
        },

        company: {
          //step 2
          company_name: '',
          homepage: '',
          bank: { iban: '', owner: '', bic: '', bankName: '' },
          tax: '',
          salestax: '',
          commercial_register_number: '',
          registration_court: '',
        },

        instance: {
          //step 3
          name: '',
          debitDifferent: false,
          debit: { iban: '', owner: '', bic: '', bankName: '' },
          acceptPrivacy: false,
        }
      },

      token: '',
      unavailable: null,
      honeypot: '',
      serverErrors: {},
      subdomainStatus: null,
      registrationError: null,
      submitting: false,
      result: null,
    }
  },

  validations () {
    return {
      form: {
        contact: {
          type: { required },
          first_name: { required },
          last_name: { required },
          mail: { required, email },
          phone: { required },
          street: { required },
          number: { required },
          city: { required },
          zip: { required },
        },

        company: {
          //step 2
          company_name: { required },
          homepage: {},
          bank: {
            iban: { required },
            owner: { required },
          },
          tax: {},
          salestax: {},
          commercial_register_number: {},
          registration_court: {},
        },

        instance: {
          name: { required },
          debit: {
            iban: { requiredIf: requiredIf(() => this.form.instance.debitDifferent) },
            owner: { requiredIf: requiredIf(() => this.form.instance.debitDifferent) },
          },
          acceptPrivacy: { sameAs: sameAs(true) },
        },
      }
    }
  },

  created(){
    this.activeStep = this.steps[0]
    this.fetchToken()
  },

  methods: {
    setLocationHash(hash){
      window.location.hash = hash
    },

    /** Signiertes Formular-Token vom Server; ohne Token ist die Registrierung abgeschaltet. */
    fetchToken(){
      fetch('/api.php?action=token', { headers: { Accept: 'application/json' } })
      .then((response) => response.json().then((json) => ({ status: response.status, json })))
      .then(({ status, json }) => {
        if(status === 200 && json.token){
          this.token = json.token
          this.unavailable = null
        }else{
          this.unavailable = json.message || UNAVAILABLE_TEXT
        }
      })
      .catch(() => {
        this.unavailable = UNAVAILABLE_TEXT
      })
    },

    /** Server-Meldung hat Vorrang vor der lokalen Pflichtfeld-Prüfung. */
    fieldError(serverField, validation){
      if(this.serverErrors[serverField]){
        return this.serverErrors[serverField]
      }
      return validation && validation.$errors.length ? validation.$errors[0] : null
    },

    nextStep(step){

      this.v$.$reset()
      this.serverErrors = {}

      switch(this.activeStep.key){
        case "contact":
          this.v$.form.contact.$touch()
          this.activateNextStep(step)
          break;
        case "company":
          this.v$.form.company.$touch()
          this.activateNextStep(step)
          break;
        case "instance":
          this.v$.form.instance.$touch()

          if (this.v$.$errors.length > 0) return
          this.apiRegistration()
          break;
      }
    },

    activateNextStep(step){
      if (this.v$.$errors.length > 0) return

      //set old step completed
      this.activeStep.completed = true
      this.setStep(step)
    },

    setStep(step){
      //set new stop
      this.setLocationHash(step.name)
      this.activeStep = step
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },

    slug(value){
      return (value || '').toLowerCase()
        .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
        .replace(/[^a-z0-9-]+/g, '-').replace(/-{2,}/g, '-').replace(/^-+|-+$/g, '').slice(0, 63)
    },

    /** Verfügbarkeit des Systemnamens im Panel (serverübergreifend) prüfen. */
    checkSubdomain(){
      const value = this.slug(this.form.instance.name)
      this.form.instance.name = value
      // Eine frühere Server-Meldung („schon vergeben“) gilt für den neuen Namen nicht mehr.
      if(this.serverErrors.subdomain){
        const rest = { ...this.serverErrors }
        delete rest.subdomain
        this.serverErrors = rest
      }
      if(value.length < 3){
        this.subdomainStatus = value ? { ok: false, text: 'Mindestens 3 Zeichen: Kleinbuchstaben, Ziffern, Bindestriche.' } : null
        return
      }
      this.subdomainStatus = { ok: false, text: 'Wird geprüft …' }

      const data = new FormData()
      data.append('token', this.token)
      data.append('subdomain', value)

      fetch('/api.php?action=check', { method: 'POST', body: data, headers: { Accept: 'application/json' } })
      .then((response) => response.ok ? response.json() : null)
      .then((json) => {
        if(!json){
          this.subdomainStatus = { ok: false, text: 'Die Verfügbarkeit lässt sich gerade nicht prüfen.' }
        }else if(json.available){
          this.subdomainStatus = { ok: true, text: `„${json.subdomain}.jonku.net“ ist frei.` }
        }else{
          this.subdomainStatus = { ok: false, text: `„${json.subdomain}“ ist leider schon vergeben.` }
          this.serverErrors = { ...this.serverErrors, subdomain: 'Der Name ist leider schon vergeben!' }
        }
      })
      .catch(() => {
        this.subdomainStatus = { ok: false, text: 'Die Verfügbarkeit lässt sich gerade nicht prüfen.' }
      })
    },

    /** Formulardaten in die Feldnamen des Servers (api.php, action=register) übersetzen. */
    buildPayload(){
      const c = this.form.contact
      const f = this.form.company
      const i = this.form.instance
      const data = new FormData()
      const fields = {
        token: this.token,
        salutation: SALUTATIONS[c.type] || '',
        first_name: c.first_name,
        last_name: c.last_name,
        email: c.mail,
        phone: c.phone,
        street: c.street,
        house_number: c.number,
        zip: c.zip,
        city: c.city,
        company: f.company_name,
        homepage: f.homepage,
        bank_owner: f.bank.owner,
        iban: f.bank.iban,
        tax_number: f.tax,
        vat_id: f.salestax,
        register_number: f.commercial_register_number,
        register_court: f.registration_court,
        subdomain: this.slug(i.name),
        debit_enabled: i.debitDifferent ? '1' : '',
        debit_bank_owner: i.debitDifferent ? i.debit.owner : '',
        debit_iban: i.debitDifferent ? i.debit.iban : '',
        accept_privacy: i.acceptPrivacy ? '1' : '',
        website: this.honeypot,
      }
      Object.keys(fields).forEach((key) => data.append(key, fields[key] == null ? '' : fields[key]))
      return data
    },

    apiRegistration(){
      if(this.submitting) return
      this.submitting = true
      this.registrationError = null

      fetch('/api.php?action=register', {
          method: 'POST',
          body: this.buildPayload(),
          headers: { Accept: 'application/json' },
      })
      .then((response) => response.json().then((json) => ({ status: response.status, json })))
      .then(({ status, json }) => {
          if(status === 200){
            this.result = json
            window.scrollTo({ top: 0, behavior: 'smooth' })
            return
          }
          this.registrationError = json.message || 'Es ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es erneut oder nehmen mit uns Kontakt auf.'
          if(json.errors){
            this.serverErrors = json.errors
            // Zum ersten Schritt mit einem Fehler springen.
            const firstStep = Math.min(...Object.keys(json.errors).map((field) => FIELD_STEP[field] ?? 2))
            if(firstStep !== this.steps.indexOf(this.activeStep)){
              this.setStep(this.steps[firstStep])
            }
          }
      })
      .catch(() => {
          this.registrationError = 'Die Verbindung wurde unterbrochen. Falls Sie in den nächsten Minuten keine E-Mail erhalten, versuchen Sie es bitte erneut oder rufen Sie uns an: 0441 249 261 0.'
      })
      .then(() => {
          this.submitting = false
      })
    }
  },
}
</script>
<style lang="">

</style>